import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { cn } from '@/shared/ui';

interface OverviewStatProps {
  readonly label: string;
  /** 표시 값 — 못 읽었으면 "—". */
  readonly value: string;
  readonly to: string;
  /** 고객이 응답해야 하는 건이 있을 때만 라임으로 강조한다. */
  readonly highlighted?: boolean;
}

/** 요약 칸 하나 — 작은 이름 아래 큰 숫자, 누르면 해당 화면으로 간다. */
export const OverviewStat = ({
  label,
  value,
  to,
  highlighted = false,
}: OverviewStatProps): ReactElement => (
  <Link
    to={to}
    className={cn(
      'group flex min-h-32 flex-col justify-between gap-6 p-5 transition-colors sm:p-6',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset',
      highlighted ? 'bg-brand-lime text-black' : 'bg-background hover:bg-muted/50',
    )}
  >
    <span className={cn('text-sm', highlighted ? 'font-semibold' : 'text-muted-foreground')}>
      {label}
    </span>
    <span className="text-[2.5rem] leading-none font-bold tracking-[-0.03em] tabular-nums">
      {value}
    </span>
  </Link>
);
